import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import './specialOfferTrips.css';

import { getSpecialOffer } from '../../api/infoAPI';

import TripCard from '../tripCard/TripCard';

import { ReactComponent as LeftInActive } from '../../assets/home/trvto_leftInActive.svg';
import { ReactComponent as RightActive } from '../../assets/home/trvto_RightActive.svg';

const SpecialOfferTrips = () => {
    const navigate = useNavigate();

    const [offer, setOffer] = useState(null);
    const [loading, setLoading] = useState(true);

    const carouselRef = useRef(null);

    const cardsPerSlide = 4;

    // =========================================================
    // FETCH SPECIAL OFFER
    // =========================================================

    useEffect(() => {
        fetchSpecialOffer();
    }, []);

    const fetchSpecialOffer = async () => {
        try {
            setLoading(true);

            const response = await getSpecialOffer();

            console.log('Special Offer Response:', response);

            const offerData = response?.data?.data;

            console.log('Special Offer Data:', offerData);

            if (!offerData || !offerData.trips?.length) {
                setOffer(null);
                return;
            }

            // Remove duplicate trips
            const uniqueTrips = Array.from(new Map(offerData.trips.map((trip) => [trip._id, trip])).values());

            setOffer({
                ...offerData,
                trips: uniqueTrips
            });
        } catch (error) {
            console.error('Failed to fetch special offer:', error);

            setOffer(null);
        } finally {
            setLoading(false);
        }
    };

    // =========================================================
    // GET SLIDE WIDTH
    // Same logic as HomeCarousel
    // =========================================================

    const getSlideWidth = () => {
        if (!carouselRef.current) {
            return 0;
        }

        const container = carouselRef.current;

        const totalCards = container.children.length;

        if (!totalCards) {
            return 0;
        }

        const numberOfSlides = Math.ceil(totalCards / cardsPerSlide);

        return container.scrollWidth / numberOfSlides;
    };

    // =========================================================
    // SCROLL LEFT
    // =========================================================

    const scrollLeft = () => {
        if (!carouselRef.current) {
            return;
        }

        const slideWidth = getSlideWidth();

        carouselRef.current.scrollBy({
            left: -slideWidth,
            behavior: 'smooth'
        });
    };

    // =========================================================
    // SCROLL RIGHT
    // =========================================================

    const scrollRight = () => {
        if (!carouselRef.current) {
            return;
        }

        const slideWidth = getSlideWidth();

        carouselRef.current.scrollBy({
            left: slideWidth,
            behavior: 'smooth'
        });
    };

    // =========================================================
    // LOADING
    // =========================================================

    if (loading) {
        return null;
    }

    // =========================================================
    // NO OFFER
    // =========================================================

    if (!offer) {
        return null;
    }

    // =========================================================
    // HOMEPAGE TRIPS
    // =========================================================

    const homepageTrips = offer.trips?.slice(0, 6) || [];

    if (!homepageTrips.length) {
        return null;
    }

    // =========================================================
    // RENDER
    // =========================================================

    return (
        <section className='special-offer-section'>
            {/* =================================================
                CAMPAIGN BANNER
            ================================================= */}

            <div className='special-offer-banner' onClick={() => navigate('/special-offers')}>
                {offer.bannerImage && (
                    <img src={offer.bannerImage} alt={offer.name} className='special-offer-banner-image' />
                )}

                <button
                    type='button'
                    className='special-offer-banner-cta'
                    onClick={(e) => {
                        e.stopPropagation();
                        navigate('/special-offers');
                    }}
                >
                    Explore Special Trips <span aria-hidden='true'>→</span>
                </button>

                {/* <div className='special-offer-banner-overlay' />

                <div className='special-offer-banner-content'>
                    <span className='special-offer-label'>SPECIAL OFFER</span>

                    <h2>{offer.name}</h2>

                    <p>Special prices on selected TRVTO trips.</p>

                    <button type='button' onClick={() => navigate('/special-offers')}>
                        Explore Special Trips
                        <span>→</span>
                    </button>
                </div> */}
            </div>

            {/* =================================================
                HEADING
            ================================================= */}

            <div className='special-offer-heading'>
                <div>
                    <span>SPECIAL OFFER</span>

                    <h2>{offer.name} Trips</h2>

                    <p>Handpicked trips included in this special offer.</p>

                    <button type='button' className='special-offer-viewall' onClick={() => navigate('/special-offers')}>
                        View all {offer.trips.length} trips →
                    </button>
                </div>

                {/* =================================================
                    ARROWS
                ================================================= */}

                {homepageTrips.length > cardsPerSlide && (
                    <div className='carouselBtnWrapper'>
                        <button className='carouselBtn' onClick={scrollLeft} aria-label='Previous trips'>
                            <LeftInActive />
                        </button>

                        <button className='carouselBtn active' onClick={scrollRight} aria-label='Next trips'>
                            <RightActive />
                        </button>
                    </div>
                )}
            </div>

            {/* =================================================
                TRIP CARDS
            ================================================= */}

            <div className='special-offer-trip-grid' ref={carouselRef}>
                <TripCard imageData={homepageTrips} type='trip' />
            </div>
        </section>
    );
};

export default SpecialOfferTrips;
